
export interface SDG {
  id: number;
  title: {
    en: string;
    ar: string;
  };
  shortTitle: {
    en: string;
    ar: string;
  };
  description: {
    en: string;
    ar: string;
  };
  palestinianContext: {
    en: string;
    ar: string;
  };
  color: string;
  icon: string;
  slug: string;
}

export const sdgsData: SDG[] = [
  {
    id: 1,
    title: {
      en: "No Poverty",
      ar: "القضاء على الفقر"
    },
    shortTitle: {
      en: "No Poverty",
      ar: "القضاء على الفقر"
    },
    description: {
      en: "End poverty in all its forms everywhere.",
      ar: "القضاء على الفقر بجميع أشكاله في كل مكان."
    },
    palestinianContext: {
      en: "Palestine faces major economic challenges due to occupation, with restricted movement and limited access to resources leading to high poverty rates. Despite these challenges, community solidarity initiatives and cooperative ventures show Palestinian resilience in addressing poverty concerns.",
      ar: "تواجه فلسطين تحديات اقتصادية كبيرة بسبب الاحتلال، مع تقييد الحركة ومحدودية الوصول إلى الموارد مما يؤدي إلى ارتفاع معدلات الفقر. وعلى الرغم من هذه التحديات، فإن مبادرات التضامن المجتمعي والمشاريع التعاونية تظهر مرونة الفلسطينيين في معالجة قضايا الفقر."
    },
    color: "#E5243B",
    icon: "/images/sdgs/sdg1.png",
    slug: "no-poverty"
  },
  {
    id: 2,
    title: {
      en: "Zero Hunger",
      ar: "القضاء التام على الجوع"
    },
    shortTitle: {
      en: "Zero Hunger",
      ar: "القضاء على الجوع"
    },
    description: {
      en: "End hunger, achieve food security and improved nutrition and promote sustainable agriculture.",
      ar: "القضاء على الجوع وتوفير الأمن الغذائي والتغذية المحسّنة وتعزيز الزراعة المستدامة."
    },
    palestinianContext: {
      en: "Food security is a critical issue in Palestine, particularly in Gaza. Despite limitations on agricultural land access, many Palestinians maintain traditional farming practices and develop urban agriculture solutions to improve food availability. Cooperative farming initiatives help communities become more self-sufficient.",
      ar: "الأمن الغذائي قضية حرجة في فلسطين، خاصة في غزة. رغم القيود على الوصول إلى الأراضي الزراعية، يحافظ العديد من الفلسطينيين على ممارسات الزراعة التقليدية ويطورون حلول الزراعة الحضرية لتحسين توفر الغذاء. تساعد مبادرات الزراعة التعاونية المجتمعات على تحقيق الاكتفاء الذاتي."
    },
    color: "#DDA63A",
    icon: "/images/sdgs/sdg2.png",
    slug: "zero-hunger"
  },
  {
    id: 3,
    title: {
      en: "Good Health and Well-being",
      ar: "الصحة الجيدة والرفاه"
    },
    shortTitle: {
      en: "Good Health",
      ar: "الصحة الجيدة"
    },
    description: {
      en: "Ensure healthy lives and promote well-being for all at all ages.",
      ar: "ضمان تمتع الجميع بأنماط عيش صحية وبالرفاهية في جميع الأعمار."
    },
    palestinianContext: {
      en: "The healthcare system in Palestine faces many obstacles, including restricted access to medical supplies, limited hospital capacity, and movement barriers for patients. Despite these challenges, Palestinian medical professionals show remarkable commitment, and innovative health initiatives emerge within communities.",
      ar: "يواجه النظام الصحي في فلسطين العديد من العقبات، بما في ذلك تقييد الوصول إلى الإمدادات الطبية، ومحدودية قدرة المستشفيات، وحواجز الحركة للمرضى. على الرغم من هذه التحديات، يظهر المهنيون الطبيون الفلسطينيون التزامًا ملحوظًا، وتظهر مبادرات صحية مبتكرة داخل المجتمعات."
    },
    color: "#4C9F38",
    icon: "/images/sdgs/sdg3.png",
    slug: "good-health"
  },
  {
    id: 4,
    title: {
      en: "Quality Education",
      ar: "التعليم الجيد"
    },
    shortTitle: {
      en: "Quality Education",
      ar: "التعليم الجيد"
    },
    description: {
      en: "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all.",
      ar: "ضمان التعليم الجيد المنصف والشامل للجميع وتعزيز فرص التعلّم مدى الحياة للجميع."
    },
    palestinianContext: {
      en: "Palestinians highly value education as a path to empowerment. Schools and universities often face disruptions and closures, yet education persists through community-based learning initiatives, digital education programs, and a strong cultural emphasis on academic achievement despite the circumstances.",
      ar: "يقدر الفلسطينيون التعليم كمسار للتمكين. تواجه المدارس والجامعات غالبًا اضطرابات وإغلاقات، ومع ذلك يستمر التعليم من خلال مبادرات التعلم المجتمعية، وبرامج التعليم الرقمية، والتركيز الثقافي القوي على التحصيل الأكاديمي رغم الظروف."
    },
    color: "#C5192D",
    icon: "/images/sdgs/sdg4.png",
    slug: "quality-education"
  },
  {
    id: 5,
    title: {
      en: "Gender Equality",
      ar: "المساواة بين الجنسين"
    },
    shortTitle: {
      en: "Gender Equality",
      ar: "المساواة بين الجنسين"
    },
    description: {
      en: "Achieve gender equality and empower all women and girls.",
      ar: "تحقيق المساواة بين الجنسين وتمكين كل النساء والفتيات."
    },
    palestinianContext: {
      en: "Palestinian women navigate both societal expectations and occupation-related challenges. Their resilience shines through women-led businesses, cultural preservation efforts, and increasing leadership roles in community organizations and politics, despite the compounded obstacles they face.",
      ar: "تتعامل المرأة الفلسطينية مع توقعات المجتمع والتحديات المتعلقة بالاحتلال. يظهر صمودها من خلال الأعمال التي تقودها النساء، وجهود الحفاظ على الثقافة، وزيادة أدوار القيادة في المنظمات المجتمعية والسياسة، على الرغم من العقبات المركبة التي تواجهها."
    },
    color: "#FF3A21",
    icon: "/images/sdgs/sdg5.png",
    slug: "gender-equality"
  },
  {
    id: 6,
    title: {
      en: "Clean Water and Sanitation",
      ar: "المياه النظيفة والنظافة الصحية"
    },
    shortTitle: {
      en: "Clean Water",
      ar: "المياه النظيفة"
    },
    description: {
      en: "Ensure availability and sustainable management of water and sanitation for all.",
      ar: "ضمان توافر المياه وخدمات الصرف الصحي للجميع وإدارتها إدارة مستدامة."
    },
    palestinianContext: {
      en: "Water access is a critical challenge in Palestine. Communities develop innovative water conservation methods, rainwater harvesting systems, and greywater recycling projects. These grassroots solutions demonstrate Palestinian ingenuity in addressing water scarcity despite limited control over water resources.",
      ar: "الوصول إلى المياه يمثل تحديًا حرجًا في فلسطين. تطور المجتمعات طرقًا مبتكرة للحفاظ على المياه، وأنظمة لحصاد مياه الأمطار، ومشاريع إعادة تدوير المياه الرمادية. تظهر هذه الحلول الشعبية براعة الفلسطينيين في معالجة ندرة المياه رغم السيطرة المحدودة على موارد المياه."
    },
    color: "#26BDE2",
    icon: "/images/sdgs/sdg6.png",
    slug: "clean-water"
  },
  {
    id: 7,
    title: {
      en: "Affordable and Clean Energy",
      ar: "طاقة نظيفة وبأسعار معقولة"
    },
    shortTitle: {
      en: "Clean Energy",
      ar: "طاقة نظيفة"
    },
    description: {
      en: "Ensure access to affordable, reliable, sustainable and modern energy for all.",
      ar: "ضمان حصول الجميع على خدمات الطاقة الحديثة الموثوقة والمستدامة بتكلفة ميسورة."
    },
    palestinianContext: {
      en: "Energy sustainability presents unique challenges in Palestine. Local renewable energy projects, particularly solar installations on rooftops of homes, schools, and businesses, are increasingly common. These initiatives provide greater energy independence and represent Palestinian commitment to sustainable development despite infrastructure limitations.",
      ar: "تقدم استدامة الطاقة تحديات فريدة في فلسطين. أصبحت مشاريع الطاقة المتجددة المحلية، خاصة التركيبات الشمسية على أسطح المنازل والمدارس والشركات، أكثر شيوعًا. توفر هذه المبادرات استقلالية أكبر في مجال الطاقة وتمثل التزام الفلسطينيين بالتنمية المستدامة رغم محدودية البنية التحتية."
    },
    color: "#FCC30B",
    icon: "/images/sdgs/sdg7.png",
    slug: "clean-energy"
  },
  {
    id: 8,
    title: {
      en: "Decent Work and Economic Growth",
      ar: "العمل اللائق ونمو الاقتصاد"
    },
    shortTitle: {
      en: "Economic Growth",
      ar: "النمو الاقتصادي"
    },
    description: {
      en: "Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all.",
      ar: "تعزيز النمو الاقتصادي المطرد والشامل والمستدام، والعمالة الكاملة والمنتجة، وتوفير العمل اللائق للجميع."
    },
    palestinianContext: {
      en: "Economic development in Palestine faces significant restrictions, but Palestinian entrepreneurs create innovative businesses that overcome barriers. Technology startups, artisan cooperatives, and social enterprises showcase Palestinian creativity and determination to build economic opportunities despite the constrained environment.",
      ar: "تواجه التنمية الاقتصادية في فلسطين قيودًا كبيرة، لكن رواد الأعمال الفلسطينيين يخلقون أعمالًا مبتكرة تتغلب على الحواجز. تعرض الشركات الناشئة في مجال التكنولوجيا، والتعاونيات الحرفية، والمؤسسات الاجتماعية إبداع الفلسطينيين وتصميمهم على بناء فرص اقتصادية رغم البيئة المقيدة."
    },
    color: "#A21942",
    icon: "/images/sdgs/sdg8.png",
    slug: "economic-growth"
  },
  {
    id: 9,
    title: {
      en: "Industry, Innovation and Infrastructure",
      ar: "الصناعة والابتكار والهياكل الأساسية"
    },
    shortTitle: {
      en: "Innovation",
      ar: "الابتكار"
    },
    description: {
      en: "Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation.",
      ar: "إقامة بُنى تحتية قادرة على الصمود، وتحفيز التصنيع الشامل للجميع، وتشجيع الابتكار."
    },
    palestinianContext: {
      en: "Despite infrastructure limitations, Palestinians demonstrate remarkable innovation. Technology hubs in cities like Ramallah nurture startups, while makers develop creative solutions to everyday challenges. This innovation ecosystem shows how Palestinians adapt and create despite physical and digital infrastructure constraints.",
      ar: "على الرغم من محدودية البنية التحتية، يظهر الفلسطينيون ابتكارًا ملحوظًا. ترعى مراكز التكنولوجيا في مدن مثل رام الله الشركات الناشئة، بينما يطور الصانعون حلولًا إبداعية للتحديات اليومية. يوضح نظام الابتكار هذا كيف يتكيف الفلسطينيون ويبدعون رغم قيود البنية التحتية المادية والرقمية."
    },
    color: "#FD6925",
    icon: "/images/sdgs/sdg9.png",
    slug: "innovation"
  },
  {
    id: 10,
    title: {
      en: "Reduced Inequalities",
      ar: "الحد من أوجه عدم المساواة"
    },
    shortTitle: {
      en: "Reduced Inequalities",
      ar: "الحد من عدم المساواة"
    },
    description: {
      en: "Reduce inequality within and among countries.",
      ar: "الحد من انعدام المساواة داخل البلدان وفيما بينها."
    },
    palestinianContext: {
      en: "Inequalities are deeply embedded in the Palestinian experience, with disparities in rights, access, and opportunities. Grassroots organizations work to address internal inequalities through inclusive programming for marginalized groups, highlighting Palestinian commitment to social justice alongside the struggle for broader equality.",
      ar: "عدم المساواة متجذر بعمق في التجربة الفلسطينية، مع تفاوتات في الحقوق والوصول والفرص. تعمل المنظمات الشعبية على معالجة أوجه عدم المساواة الداخلية من خلال برامج شاملة للفئات المهمشة، مما يبرز التزام الفلسطينيين بالعدالة الاجتماعية إلى جانب النضال من أجل المساواة على نطاق أوسع."
    },
    color: "#DD1367",
    icon: "/images/sdgs/sdg10.png",
    slug: "reduced-inequalities"
  },
  {
    id: 11,
    title: {
      en: "Sustainable Cities and Communities",
      ar: "مدن ومجتمعات محلية مستدامة"
    },
    shortTitle: {
      en: "Sustainable Cities",
      ar: "مدن مستدامة"
    },
    description: {
      en: "Make cities and human settlements inclusive, safe, resilient and sustainable.",
      ar: "جعل المدن والمستوطنات البشرية شاملة للجميع وآمنة وقادرة على الصمود ومستدامة."
    },
    palestinianContext: {
      en: "Urban sustainability in Palestine involves preserving historic architecture while addressing modern challenges. Community-led initiatives focus on public space revitalization, urban gardening, and cultural heritage preservation, demonstrating Palestinian commitment to creating livable cities despite planning restrictions and limited resources.",
      ar: "تتضمن الاستدامة الحضرية في فلسطين الحفاظ على العمارة التاريخية مع معالجة التحديات الحديثة. تركز المبادرات المجتمعية على إحياء المساحات العامة، والبستنة الحضرية، والحفاظ على التراث الثقافي، مما يدل على التزام الفلسطينيين بإنشاء مدن صالحة للعيش رغم قيود التخطيط والموارد المحدودة."
    },
    color: "#FD9D24",
    icon: "/images/sdgs/sdg11.png",
    slug: "sustainable-cities"
  },
  {
    id: 12,
    title: {
      en: "Responsible Consumption and Production",
      ar: "الاستهلاك والإنتاج المسؤولان"
    },
    shortTitle: {
      en: "Responsible Consumption",
      ar: "الاستهلاك المسؤول"
    },
    description: {
      en: "Ensure sustainable consumption and production patterns.",
      ar: "ضمان وجود أنماط استهلاك وإنتاج مستدامة."
    },
    palestinianContext: {
      en: "Traditional Palestinian practices often align with sustainable consumption principles. Local initiatives promote waste reduction, recycling, and upcycling. Traditional crafts that use sustainable materials are being revitalized, merging cultural heritage preservation with environmental consciousness.",
      ar: "غالبًا ما تتوافق الممارسات الفلسطينية التقليدية مع مبادئ الاستهلاك المستدام. تعزز المبادرات المحلية تقليل النفايات وإعادة التدوير والتدوير العلوي. يتم إحياء الحرف التقليدية التي تستخدم مواد مستدامة، مما يدمج الحفاظ على التراث الثقافي مع الوعي البيئي."
    },
    color: "#BF8B2E",
    icon: "/images/sdgs/sdg12.png",
    slug: "responsible-consumption"
  },
  {
    id: 13,
    title: {
      en: "Climate Action",
      ar: "العمل المناخي"
    },
    shortTitle: {
      en: "Climate Action",
      ar: "العمل المناخي"
    },
    description: {
      en: "Take urgent action to combat climate change and its impacts.",
      ar: "اتخاذ إجراءات عاجلة للتصدي لتغير المناخ وآثاره."
    },
    palestinianContext: {
      en: "Climate change compounds existing challenges in Palestine, with water scarcity and agricultural impacts being particularly severe. Environmental organizations lead community awareness campaigns, advocate for policy changes, and implement adaptation strategies, showing Palestinian commitment to climate action despite limited resources.",
      ar: "يزيد تغير المناخ من التحديات القائمة في فلسطين، مع ندرة المياه والتأثيرات الزراعية بشكل خاص. تقود المنظمات البيئية حملات التوعية المجتمعية، وتدعو إلى تغييرات في السياسات، وتنفذ استراتيجيات التكيف، مما يظهر التزام الفلسطينيين بالعمل المناخي رغم محدودية الموارد."
    },
    color: "#3F7E44",
    icon: "/images/sdgs/sdg13.png",
    slug: "climate-action"
  },
  {
    id: 14,
    title: {
      en: "Life Below Water",
      ar: "الحياة تحت الماء"
    },
    shortTitle: {
      en: "Life Below Water",
      ar: "الحياة تحت الماء"
    },
    description: {
      en: "Conserve and sustainably use the oceans, seas and marine resources for sustainable development.",
      ar: "حفظ المحيطات والبحار والموارد البحرية واستخدامها على نحو مستدام لتحقيق التنمية المستدامة."
    },
    palestinianContext: {
      en: "Gaza's coastline faces significant challenges including pollution, restricted fishing access, and marine ecosystem damage. Despite these difficulties, local initiatives work to clean beaches, protect marine life, and support sustainable fishing practices, demonstrating Palestinian care for their maritime environment.",
      ar: "يواجه ساحل غزة تحديات كبيرة بما في ذلك التلوث، وتقييد الوصول إلى الصيد، وتلف النظام البيئي البحري. على الرغم من هذه الصعوبات، تعمل المبادرات المحلية على تنظيف الشواطئ، وحماية الحياة البحرية، ودعم ممارسات الصيد المستدامة، مما يدل على اهتمام الفلسطينيين ببيئتهم البحرية."
    },
    color: "#0A97D9",
    icon: "/images/sdgs/sdg14.png",
    slug: "life-below-water"
  },
  {
    id: 15,
    title: {
      en: "Life on Land",
      ar: "الحياة في البرّ"
    },
    shortTitle: {
      en: "Life on Land",
      ar: "الحياة في البر"
    },
    description: {
      en: "Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss.",
      ar: "حماية النظم الإيكولوجية البرية وترميمها وتعزيز استخدامها على نحو مستدام، وإدارة الغابات على نحو مستدام، ومكافحة التصحر، ووقف تدهور الأراضي وعكس مساره، ووقف فقدان التنوع البيولوجي."
    },
    palestinianContext: {
      en: "Biodiversity conservation in Palestine faces challenges from habitat fragmentation, land restrictions, and environmental degradation. Conservation projects focus on protecting native species, restoring natural areas, and documenting Palestinian flora and fauna. These efforts connect environmental protection with cultural heritage preservation.",
      ar: "تواجه المحافظة على التنوع البيولوجي في فلسطين تحديات من تجزئة الموائل، وقيود الأراضي، والتدهور البيئي. تركز مشاريع الحفظ على حماية الأنواع المحلية، واستعادة المناطق الطبيعية، وتوثيق النباتات والحيوانات الفلسطينية. تربط هذه الجهود بين حماية البيئة والحفاظ على التراث الثقافي."
    },
    color: "#56C02B",
    icon: "/images/sdgs/sdg15.png",
    slug: "life-on-land"
  },
  {
    id: 16,
    title: {
      en: "Peace, Justice and Strong Institutions",
      ar: "السلام والعدل والمؤسسات القوية"
    },
    shortTitle: {
      en: "Peace and Justice",
      ar: "السلام والعدل"
    },
    description: {
      en: "Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels.",
      ar: "التشجيع على إقامة مجتمعات مسالمة لا يهمش فيها أحد من أجل تحقيق التنمية المستدامة، وإتاحة إمكانية وصول الجميع إلى العدالة، وبناء مؤسسات فعالة وخاضعة للمساءلة وشاملة للجميع على جميع المستويات."
    },
    palestinianContext: {
      en: "Justice and peace are central to Palestinian aspirations. Community organizations work to strengthen civil society, document human rights, and build democratic traditions. Youth-led initiatives promote dialogue, civic engagement, and nonviolent approaches to conflict resolution, showing Palestinian commitment to building just and peaceful institutions.",
      ar: "العدالة والسلام من الطموحات المركزية للفلسطينيين. تعمل المنظمات المجتمعية على تعزيز المجتمع المدني، وتوثيق حقوق الإنسان، وبناء تقاليد ديمقراطية. تعزز المبادرات التي يقودها الشباب الحوار، والمشاركة المدنية، والنهج اللاعنفية لحل النزاعات، مما يظهر التزام الفلسطينيين ببناء مؤسسات عادلة وسلمية."
    },
    color: "#00689D",
    icon: "/images/sdgs/sdg16.png",
    slug: "peace-justice"
  },
  {
    id: 17,
    title: {
      en: "Partnerships for the Goals",
      ar: "عقد الشراكات لتحقيق الأهداف"
    },
    shortTitle: {
      en: "Partnerships",
      ar: "الشراكات"
    },
    description: {
      en: "Strengthen the means of implementation and revitalize the global partnership for sustainable development.",
      ar: "تعزيز وسائل التنفيذ وتنشيط الشراكة العالمية من أجل التنمية المستدامة."
    },
    palestinianContext: {
      en: "Collaboration is essential for sustainable development in Palestine. Local organizations partner with international institutions, diaspora communities, and each other to enhance impact. These partnerships facilitate knowledge exchange, resource sharing, and capacity building, demonstrating how Palestinians leverage collective action to advance sustainability goals.",
      ar: "التعاون ضروري للتنمية المستدامة في فلسطين. تتشارك المنظمات المحلية مع المؤسسات الدولية ومجتمعات الشتات وبعضها البعض لتعزيز التأثير. تسهل هذه الشراكات تبادل المعرفة ومشاركة الموارد وبناء القدرات، مما يوضح كيف يستفيد الفلسطينيون من العمل الجماعي لتعزيز أهداف الاستدامة."
    },
    color: "#19486A",
    icon: "/images/sdgs/sdg17.png",
    slug: "partnerships"
  }
];
